
import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import SearchIcon from "@mui/icons-material/Search";
import ListSubheader from "@mui/material/ListSubheader";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import FavoriteBorder from "@mui/icons-material/StarBorder";
import Favorite from "@mui/icons-material/Star";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { esES } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import {
  DEFAULT_AVATAR_URL,
  EntityFavoriteStatus,
  RegistrationStatus,
} from "../../common/enum";
import {
  getEntitiesList,
  setEntitiesLimit,
  setEntitiesOffset,
} from "../AdminView/adminSlice";
import { debounce } from "lodash";
import { Avatar, Button, Tooltip } from "@mui/material";
import Loader from "../../components/Loader";
import { LoadingButton } from "@mui/lab";
import { addEntityFavorite, getEntityFavorites } from "./slice";
import { useSnackbar } from "notistack";
import FavoriteEntity from "./FavoriteEntity";
import { setCollectorInviteNames } from "../DonationView/slice";

function TabPanel(props) {
  const { children, value, tabValue, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabValue !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {tabValue === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  tabValue: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function CollectorInvitation({ personName, setPersonName, t  , entityUpdate, isBlacklist}) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [searchText, setSearchText] = React.useState("");
  const [searchEntities, setSearchEntities] = React.useState([]);
  const [value, setValue] = React.useState(0);
  const timer = React.useRef(null);
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      drawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationDialog,
      loading,
      headerTitle,
      
    },
    donationCart: { collectorInviteNames },
    auth: {
      user: { userId, entityId },
      profile: { entity },
    },
    collectorInvite: { entitiesFavorites },
  } = useSelector((state) => state);

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (entitiesList.length > 0) {
      const filterEntity = entitiesList.filter((data) => {
        return (
          data?.entity?.isGroupEntity === false ||
          (data?.entity?.isGroupEntity && !data?.entity?.isParentEntity)
        );
      });
      const seenIds = new Set();
      const filteredArr = filterEntity.filter((item) => {
        const id = item?.entity?.id;
        if (seenIds.has(id)) {
          return false; // Já vimos este ID, removemos.
        }
        seenIds.add(id); // Adiciona o ID ao conjunto.
        return true; // Este é único, mantemos.
      });
      //const filteredArr = [...new Set(filterEntity)];
      setSearchEntities((v) => [...v, ...filteredArr]);
    }
  }, [entitiesList]);

  const getFavoriteEntities = React.useCallback(() => {
    const payload = {
      entityId: userId,
      status: EntityFavoriteStatus.favorite,
      isBlacklist: false,
    };
    dispatch(getEntityFavorites(payload));
  }, [dispatch, userId]);

  const getBlacklistedEntities = React.useCallback(() => {
    const payload = {
      entityId: userId,
      status: EntityFavoriteStatus.blacklisted,
      isBlacklist: false,
    };
    dispatch(getEntityFavorites(payload));
  }, [dispatch, userId]);

  React.useEffect(() => {
    getFavoriteEntities();
    getBlacklistedEntities();
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
      status: RegistrationStatus.active,
      isDonorExcluded: true,
      entityName: value.entityName,
      isBlacklist: isBlacklist,
      entityUpdate: entityUpdate
    };
    dispatch(getEntitiesList(data));
    dispatch(setEntitiesLimit(limit));
    dispatch(setEntitiesOffset(offset));
  }, 1000);

  const handleSerachBox = (event) => {
    setSearchEntities([]);
    setSearchText(event.target.value);
    if (event.target.value.length > 0) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        let value = {
          skip: 0,
          take: 50,
          entityName: event.target.value,
          
        };
        debouncedApiCall(value);
      }, 1000);
    }
  };

  const onHandleViewMore = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      let value = {
        skip: entitiesOffset + entitiesLimit,
        take: 50 + entitiesLimit,
        entityName: searchText,
      };
      debouncedApiCall(value);
    }, 1000);
  };

  const handleFavorite = (e, name) => {
    const data = {
      id: entitiesFavorites.find(
        (f) => f.favorites.entityId === name?.entity.entityId
      )
        ? entitiesFavorites.find(
            (f) => f.favorites.entityId === name?.entity.entityId
          ).favorites.id
        : 0,
      entityId: name?.entity.entityId,
      status: e.target.checked ? EntityFavoriteStatus.favorite : "",
      updatedBy: userId,
    };
    dispatch(addEntityFavorite(data))
      .unwrap()
      .then((res) => {
        getFavoriteEntities();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleCollectorName = (e, name) => {
    //const allPerson = personName.includes(name);
    const allPerson = personName.some(item => item.entity.id === name.entity.id);
    //const collectorNames = collectorInviteNames.includes(name);
    const collectorNames = collectorInviteNames.some(item => item.entity.id === name.entity.id);
    if (allPerson && collectorNames) {
      const dat = personName.filter((n) => n.entity.id !== name?.entity.id);
      setPersonName([...dat]);
      dispatch(setCollectorInviteNames([...dat]));
    } else {
      setPersonName((v) => [...v, name]);
      dispatch(setCollectorInviteNames([...personName, name]));
    }
  };
 // console.log("search entities", searchEntities);
  const removeData = () => {
    setSearchEntities([]);
  };


  const [profileImages, setProfileImages] = useState(new Map());

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of searchEntities) {
      const id = item?.entity?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
          newMap.set(item.entity.entityId, imageUrl);
        }else{
            newMap.set(item.entity.entityId, DEFAULT_AVATAR_URL);
        }
        
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [searchEntities, dispatch]);

  return (
    <div>
      <FormControl sx={{ width: 1 }}>
        <InputLabel id="demo-multiple-chip-label" sx={{backgroundColor:"white"}}>
          {t("benificiaryEntity") + ' (Opcional)'}
        </InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          fullWidth
          value={personName.map((p) => p?.entity?.entityName)}
          //   onChange={handleChange}
          onClose={removeData}
          onOpen={removeData}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1" fontFamily={"Poppins"}>
                {selected[0]}
              </Typography>
              {selected.length > 1 && (
                <Chip
                  label={`+${selected.length - 1}`}
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    m: "5px",
                    "& .MuiChip-label": { fontWeight: "bold" },
                  }}
                />
              )}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          <ListSubheader>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label="basic tabs example"
              >
                <Tab label={t("all")} {...a11yProps(0)} />
                <Tab label={t("entityFavorite")} {...a11yProps(1)} />
              </Tabs>
            </Box>
          </ListSubheader>
          <TabPanel value={value} tabValue={value} index={0}>
            <ListSubheader>
              <TextField
                size="small"
                sx={{
                  mt: 1,
                }}
                // Autofocus on textfield
                autoFocus
                placeholder={t("typeToSearch")}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 5 },
                }}
                onChange={handleSerachBox}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  } else if (e.key === "Enter") {
                    handleSerachBox(e);
                  }
                }}
              />
            </ListSubheader>
            {loading && <Loader t={t} />}
            {searchEntities.length > 0 &&
              
              searchEntities.map((name) => (
                <MenuItem
                  key={name?.entity.entityId}
                  value={name?.entity.entityName}
                  //   style={getStyles(name?.entity.entityName, personName, theme)}
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <Avatar
                    src={
                      name?.entity?.profilePicture !== "string"
                        ? profileImages.get(name?.entity.entityId)
                        : DEFAULT_AVATAR_URL
                    }
                    variant="rounded"
                    sx={{ backgroundColor: "green", mr: 1 }}
                  />
                  <ListItemText
                    primary={
                      name?.entity.entityName
                      // name?.entity?.isGroupEntity
                      //   ? name?.addresses.find(
                      //       (address) =>
                      //         address?.addressId ===
                      //         name?.entity.entityAddressId
                      //     )?.name?.entity.entityName
                      //   : name?.entity.entityName
                    }
                  />
                  <Tooltip title= 'Selecionar Entidade'>
                  <Checkbox
                  checked={personName.find(
                    (f) =>
                      f.entity.entityId === name?.entity.entityId 
                      
                  )}
                    //checked={personName.entity.includes(name.entity)}
                    //checked = {personName.length > 0 && personName.map((p) => Object.values(p.entity.entityName).includes("test1") == name.entity.entityName ? true : false)}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<CheckCircleIcon />}
                    sx={{
                      p: 0,
                      m: 0,
                      ml: 2,
                      justifyContent: "space-between",
                      "& .MuiSvgIcon-root": {
                        fontSize: "28px !important",
                        color: "#37B34A !important",
                        mr: "0px !important",
                      },
                    }}
                    onChange={(e) => handleCollectorName(e, name)}
                  />
                  </Tooltip>
                  <Tooltip title= 'Entidade beneficiária favorita'>

                  <Checkbox
                    checked={entitiesFavorites.find(
                      (f) =>
                        f.favorites.entityId === name?.entity.entityId &&
                        f.favorites.status === EntityFavoriteStatus.favorite
                    )}
                    icon={<FavoriteBorder />}
                    checkedIcon={<Favorite />}
                    color="warning"
                    onChange={(e) => handleFavorite(e, name)}
                  />
                  </Tooltip>
                </MenuItem>
              ))}
            {/* {searchEntities.length > 0 &&
              searchEntities.length < entitiesCount && (
                <LoadingButton
                  loading={loading}
                  sx={{
                    textAlign: "center",
                    width: 1,
                    mt: 1,
                    borderRadius: "4px",
                  }}
                  onClick={onHandleViewMore}
                >
                  {t("viewMore")}
                </LoadingButton>
              )} */}
            {!loading && searchEntities.length === 0 && (
              <Typography
                variant="body1"
                fontFamily={"Poppins"}
                textAlign={"center"}
              >
                {t("noEntites")}
              </Typography>
            )}
          </TabPanel>
          <TabPanel value={value} tabValue={value} index={1}>
            <FavoriteEntity
              personName={personName}
              setPersonName={setPersonName}
              t={t}
              isBlacklist={isBlacklist}
            />
          </TabPanel>
        </Select>
      </FormControl>
    </div>
  );
}
